import { render, staticRenderFns } from "./NotificationsTasks.vue?vue&type=template&id=de6864c4&scoped=true&lang=pug"
import script from "./NotificationsTasks.vue?vue&type=script&lang=ts"
export * from "./NotificationsTasks.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsTasks.vue?vue&type=style&index=0&id=de6864c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6864c4",
  null
  
)

export default component.exports